// Test
import { init } from '@nosto/preact'

import serpComponent from './serp'
import categoryComponent from './category'
import autocompleteComponent from './autocomplete'
import historyComponent from './history'
import { defaultConfig } from './config'

import './styles/index.css'

const newSearchEnabled = window?.cj?.nosto?.newSearchFeatureEnabled

init({
    ...window.nostoTemplatesConfig,
    serpComponent,
    historyComponent: newSearchEnabled ? undefined : historyComponent,
    autocompleteComponent: newSearchEnabled ? undefined : autocompleteComponent,
    categoryComponent,
    inputCssSelector: '#search',
    //contentCssSelector: '#app',
    contentCssSelector: '#searchpage-nosto-results',

    serpUrlMapping: {
        query: 'q',
        'products.page': 'page',
        'products.sort': 'sort',
        'products.filter.extra.cjx-flair_tags': 'offers',
        'products.filter.tags1': 'interests',
        'products.filter.price': 'price',
        'products.filter.extra.cjx-ships_to': 'ships_to',
        'products.filter.customFields.cjx-ships_from': 'ships_from',
    },
    compressUrlParameters: true,

    // Comment `serpPath` to render on the same page
    serpPath: newSearchEnabled ? '' : '/search',
    serpPathRedirect: newSearchEnabled ? false : true,
    autocompleteMinLength: 1,
    //the application after search submission will redirect the page to the search page specified in serpPath and fetch the page
    serpQuery: {
        products: {
            fields: [
                'productId', 'url', 'name', 'imageUrl', 'thumbUrl', 'description', 'brand',
                'availability', 'price', 'priceText', 'listPrice', 'ratingValue', 'reviewCount',
                'customFields.key', 'customFields.value'
            ],
            facets: ['*'],
            size: defaultConfig.serpSize,
            from: 0,
        },
    },
    autocompleteQuery: {
        products: {
            fields: newSearchEnabled ?
                [
                    'productId'
                ] :
                [
                    'productId', 'url', 'name', 'imageUrl', 'thumbUrl', 'brand',
                    'availability', 'price', 'priceText', 'listPrice', 'ratingValue', 'reviewCount',
                    'customFields.key', 'customFields.value'
                ],
            size: defaultConfig.autocompleteSize,
        },
        keywords: {
            size: newSearchEnabled ? 1 : 5,
            fields: [
                'keyword', '_highlight.keyword'
            ],
        },
    },
    // For Category Merchandising
    categoryCssSelector: '#nosto-main-category-page',
    isCategoryPage: () => document.getElementById('nosto-main-category-page') !== null,
    categoryQuery: () => {
        return {
            name: 'categories',
            products: {
                //categoryPath: `${window.cj?.collection?.title}`,
                categoryId: `${window.cj?.collection?.id}`,
                size: defaultConfig.serpSize,
                from: 0,
            }
        }
    },
})
